// Home slider image swiper js
var swiper = new Swiper('.block__homeslider-wrapper', {
    // Optional parameters
    loop: true,
    slidesPerView: 2,
    navigation: {
        nextEl: '.block__swiper-nextbtn',
        prevEl: '.block__swiper-prevbtn',
    },
    breakpoints: {
        // when window width is >= 992px
        992: {
            slidesPerView: 2
        },
        // when window width is < 768px
        0: {
            slidesPerView: 1
        }
    }
});

//  best seller section 

var swiper = new Swiper(".best_seller_block", {
    slidesPerView: 4,
    spaceBetween: 30,
    freeMode: true,
    navigation: {
        nextEl: ".bestseller_block__swiper-nextbtn",
        prevEl: ".bestseller_block__swiper-prevbtn",
    },
    breakpoints: {
        992: { // 992px and above
            slidesPerView: 4,
            spaceBetween: 30,
        },
        768: { // 768px and above
            slidesPerView: 3,
            spaceBetween: 30,
        },
        0: { // 0px and above
            slidesPerView: 2,
            spaceBetween: 10,
        }
    }
});


//   collection banner  section

var swiper = new Swiper(".collection_banner-block", {
    slidesPerView: 2,
    spaceBetween: 10,
    freeMode: true,
    navigation: {
        nextEl: ".collection_banner_block__swiper-nextbtn",
        prevEl: ".collection_banner_block__swiper-prevbtn",
    },
    breakpoints: {
        // when window width is <= 576px
        767: {
            slidesPerView: 2,
            spaceBetween: 30,
            freeMode: true,
            navigation: {
                nextEl: ".collection_banner_block__swiper-nextbtn",
                prevEl: ".collection_banner_block__swiper-prevbtn",
            },
        }
    }
});


//  gift-basket section
var swiper = new Swiper(".gift_basket__block-sldier", {
    slidesPerView: 2,
    spaceBetween: 10,
    freeMode: true,
    navigation: {
        nextEl: ".gift_basket_block__swiper-nextbtn",
        prevEl: ".gift_basket_block__swiper-prevbtn",
      },
      breakpoints: {
        // when window width is <= 576px
        767: {
            slidesPerView: 2,
            spaceBetween: 30,
            freeMode: true,
            navigation: {
                nextEl: ".gift_basket_block__swiper-nextbtn",
                prevEl: ".gift_basket_block__swiper-prevbtn",
            },
        }
    }
  });

  //  blog post section 

  var swiper = new Swiper(".blog__block--swiper", {
    slidesPerView: 3,
    spaceBetween: 30,
    freeMode: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    breakpoints: {
        992: { // 992px and above
            slidesPerView: 4,
            spaceBetween: 30,
        },
        768: { // 768px and above
            slidesPerView: 3,
            spaceBetween: 30,
        },
        0: { // 0px and above
            slidesPerView: 1,
            spaceBetween: 10,
        }
    }
});

// fotter mobile togle code

document.addEventListener("DOMContentLoaded", function() {
    // Check if viewport width is less than or equal to 768px (adjust as per your design)
    if (window.innerWidth <= 992) {
        let tabs = document.querySelectorAll('.footer_block-mobile-togle-wrapper');
        let coll = document.querySelectorAll('.footer-block__details-content');
        let plus = document.querySelectorAll('.foter_block-plus');
        let minus = document.querySelectorAll('.foter_block-minus');

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                if (coll[index].style.display === "block") {
                    coll[index].style.display = "none";
                    minus[index].style.display = "none";
                    plus[index].style.display = "block";
                } else {
                    coll[index].style.display = "block";
                    minus[index].style.display = "block";
                    plus[index].style.display = "none";
                }
            });
        });
    }
});

window.addEventListener("load", (event) => {
    subscription_plan();

    function subscription_plan(){
        var interval = setInterval(function() {
            if ($('.rc-container-wrapper').find('.rc-radio-group__options').length > 0) {
                var subscription_plan_wrap = $('.rc-container-wrapper .rc-selling-plans');
                $('.rc_widget__option--subsave .rc_widget__option__label').append(subscription_plan_wrap);
                clearInterval(interval); 
            } else {
            }
        }, 1000);
    }
});

   
$(document).ready(function() {
    // Iterate over each set of tab categories
    $('.block__tab_cetegorys').each(function() {
        var active, content, links = $(this).find('.block__element_box');

        // Set the first link as active and show its content
        active = links.first().addClass('active');
        content = $($(active).attr('data-cetegory'));
        showMatchingDivs(active.attr('data-cetegory'));

        // Hide the content of all other links
        links.not(':first').each(function() {
            hideMatchingDivs($(this).attr('data-cetegory'));
        });

        // Attach click event to each link
        links.click(function(e) {
            e.preventDefault();

            // Remove active class and hide current content for both containers
            active.removeClass('active');
            hideMatchingDivs(active.attr('data-cetegory'));

            // Update active and content variables
            active = $(this);
            showMatchingDivs(active.attr('data-cetegory'));

            // Add active class
            active.addClass('active');
        });
    });

    // Function to show matching divs in both containers
    function showMatchingDivs(dataCategory) {
        // Show the div in the first container
        $('.block_wrapper_productsection').find(dataCategory).show();

        // Show the div in the second container
        $('.block__wrapper--view-product').find(dataCategory).show();
    }

    // Function to hide matching divs in both containers
    function hideMatchingDivs(dataCategory) {
        // Hide the div in the first container
        $('.block_wrapper_productsection').find(dataCategory).hide();

        // Hide the div in the second container
        $('.block__wrapper--view-product').find(dataCategory).hide();
    }
});

$(document).ready(function() {
    let div_second = document.querySelector('.block__wrapper--view-product');
    let button = document.querySelector('.collection-tab   .collection__view-all');
    let text_button = document.querySelector('.collection__view-all #view-all-button');

    // Ensure both elements exist before attaching event listener
    if (div_second && button) {
        // Initially hide the second section
        div_second.style.display = 'none';

        // Add event listener to the button to toggle the second section
        button.addEventListener('click', () => {
            // Check the current display state and toggle
            if (div_second.style.display === 'none' || div_second.style.display === '') {
                div_second.style.display = 'block';
                text_button.textContent = "Show less"
            } else {
                div_second.style.display = 'none';
                text_button.textContent = "View more"
            }
        });
    }
});


// eu page events js 
document.querySelectorAll('.block__tab_cetegorys .block__element_box').forEach(function(element) {
    element.addEventListener('click', function() {
        var tab_id = this.getAttribute('data-cetegory');

        document.querySelectorAll('.block__tab_cetegorys .block__element_box').forEach(function(el) {
            el.classList.remove('current');
        });
        document.querySelectorAll('.tab-content').forEach(function(content) {
            content.classList.remove('current');
        });

        this.classList.add('current');
        document.getElementById(tab_id).classList.add('current');
    });
});


$(document).ready(function() {
    // //  collectioon tabs js 
    // $('.block__tab_cetegorys').each(function() {
    //     var active, content, links = $(this).find('.block__element_box');

    //     // Set the first link as active and show its content
    //     active = links.first().addClass('active');
    //     content = $($(active).attr('data-cetegory'));
    //     content.show();

    //     // Hide the content of all other links
    //     links.not(':first').each(function () {
    //         $($(this).attr('data-cetegory')).hide();
    //     });

    //     // Attach click event to each link
    //     links.click(function(e) {
    //         e.preventDefault();
    //         active.removeClass('active');
    //         content.hide();
            
    //         active = $(this);
    //         content = $($(this).attr('data-cetegory'));

    //         active.addClass('active');
    //         content.show();
    //     });
    // });

    // Blog search article
    $(document).on('keyup','.blog__search input#search-blogs',function(e){
        var current_elementval = $(this);
        blog_predictive_search(current_elementval);
    });
    $(document).on('click','.blog__search button',function(e){
        var current_elementval = $(this);
        blog_predictive_search(current_elementval);
    });
    function blog_predictive_search(current_elementval){
        var current_val = current_elementval;
        var value = $(current_val).val().toLowerCase(),
            matchingItems = 0;
        $(".blog-articles__article .card__heading").each(function () {
            var text = $(this).text().toLowerCase(),
                match = text.indexOf(value) > -1;
            $(this).parents('.blog-articles__article').toggle(match), match && matchingItems++;
        });
        if(value === ""){
            $('.blog-articles__article .card__heading').each(function (index) {                   
                    $(this).parents('.blog-articles__article').fadeIn("slow").removeClass("hide");
            })
        }else{}
    }

    // Account page
    $('.main_account_orderdetailclick').click(function(e){
        e.preventDefault();
        var currentorderno = $(this).attr('data-ordernobtn');
        $('.main_account_orderhistory-subcontent[data-ordernocontent="'+currentorderno+'"]').addClass('active-suborder-detail');
        $('.main_account_orderhistory, .main_account_tabcontentwrapper .account_main_heading').css("display","none");
    });

    $('.main_account_order-subheadarrow').click(function(e){
        e.preventDefault();
        $(this).parents('.main_account_orderhistory-subcontent').removeClass('active-suborder-detail');
        $('.main_account_orderhistory, .main_account_tabcontentwrapper .account_main_heading').css("display","block");
    });

    // Account tab

    let currentTab = localStorage.getItem('account_current_tab');

    if(currentTab && currentTab != "subscription-management"){ 
        if(document.querySelectorAll(`.main_account-tabitem[data-accounttab="${currentTab}"]`).length > 0){
            const firstEle = document.querySelectorAll(`.main_account-tabitem[data-accounttab="${currentTab}"]`)[0];
            const innerEle = firstEle.querySelector('a').innerHTML;
            $('.main_account-tab-mobilefilter .current_tab').html(innerEle);
            $(`.main_account-tabitem[data-accounttab="${currentTab}"]`).addClass("main_accounttab-active");
            $(`.main_account_tabcontentwrap[data-accounttabcontent="${currentTab}"]`).addClass("main_accounttabcontent-active");
        }else{}
        
    } else {
        const currentText = $('.main_account-tablist .main_account-tabitem:first-child').find('a').html();
        $('.main_account-tab-mobilefilter .current_tab').html(currentText);
        $('.main_account-tablist .main_account-tabitem:first-child').addClass("main_accounttab-active");
        $('.main_account_tabcontentwrapper .main_account_tabcontentwrap:first-child').addClass("main_accounttabcontent-active");
    }

    $(".main_account-tabitem:not(.main_account-tabitemlogout)").on("click", function(e){
        let currentTab = $(this).attr("data-accounttab");
        localStorage.setItem("account_current_tab", currentTab);
        $(".main_account-tabitem").removeClass('main_accounttab-active');
        $(".main_account_tabcontentwrap").removeClass("main_accounttabcontent-active");
            
        $(this).addClass("main_accounttab-active");
        $(`.main_account_tabcontentwrap[data-accounttabcontent="${currentTab}"]`).addClass("main_accounttabcontent-active");
        var firstEle = document.querySelectorAll(`.main_account-tabitem[data-accounttab="${currentTab}"]`)[0];
        var innerEle = firstEle.querySelector('a').innerHTML;
        $('.main_account-tab-mobilefilter .current_tab').html(innerEle);
        $('.main_account-tab-mobilefilter').siblings(".main_account-tablist").slideToggle("500");
    });

    $(".main_account-tab-mobilefilter").click(function(){
        $(this).toggleClass("tab-filter-open");
        $(this).siblings(".main_account-tablist").slideToggle("500");
    });

    $('.main_account_reorder-txt').click(function(e){
        e.preventDefault();
        var orderAllproduct = [];
        $(this).parents('.active-suborder-detail').find('.main_account_order-detail-content .main_account_order-detail-innerbody').each(function(){
            var current_ordervariant = $(this).find('input[name="ordervariantid"]').val();
            orderAllproduct.push( {
                variantId: current_ordervariant,
                quantity: 1
            });
        });
        function moveAlong(){
            if (orderAllproduct.length) {
              var request = orderAllproduct.shift();
              var tempId= request.variantId;
              var tempQty = request.quantity;
              var params = {
                type: 'POST',
                url: '/cart/add.js',
                data: 'quantity='+tempQty+'&id='+tempId,
                dataType: 'json',
                success: function(line_item) { 
                  console.log("Product Added to Cart");
                  if (orderAllproduct.length) {
                    moveAlong();
                  }else{
                  }
    
                },
                error: function() {
                  moveAlong();
    
                }
              };
              $.ajax(params);
            }
            else {
            }  
          };
          moveAlong();

    })
});


// robusto -slider 
var swiper = new Swiper('.robusto_block-swiper', {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    navigation: {
        nextEl: '.block__rebusto-nextbtn',
        prevEl: '.block__rebusto-prevbtn',
    },
    breakpoints: {
        // when window width is >= 992px
        992: {
            slidesPerView: 1
        },
        // when window width is < 768px
        0: {
            slidesPerView: 1
        }
    }
});

//  subscriber-image swiper section
var swiper = new Swiper(".block__subscriber--swipermain", {
    slidesPerView: 1,
    freeMode: true,
    loop: true,
    navigation: {
        nextEl: ".subscriber_block__swiper-nextbtn",
        prevEl: ".subscriber_block__swiper-prevbtn",
      },
      breakpoints: {
        // when window width is <= 576px
        767: {
            slidesPerView: 1,
            freeMode: true,
            navigation: {
                nextEl: ".subscriber_block__swiper-nextbtn",
                prevEl: ".subscriber_block__swiper-prevbtn",
            },
        }
    }
  });
  
  //  subscriber & save swiper section
var swiper = new Swiper(".block__sub-save--swiper", {
    slidesPerView: 1,
    freeMode: true,
    loop: true,
    navigation: {
        nextEl: ".sub-save_block__swiper-nextbtn",
        prevEl: ".sub-save_block__swiper-prevbtn",
      },
      breakpoints: {
        // when window width is <= 576px
        767: {
            slidesPerView: 1,
            freeMode: true,
            navigation: {
                nextEl: ".sub-save_block__swiper-nextbtn",
                prevEl: ".sub-save_block__swiper-prevbtn",
            },
        }
    }
  });


//   header mega menu js 

let items = document.querySelectorAll(".mega-menu");
let currentItemIndex;

items.forEach((item, itemIndex) => {
  const content = item.querySelector(".mega-menu__content");
  var current_item = item;
  item.addEventListener("mouseover", () => {
    // Close the previously opened menu, if it's not the current one
    if (currentItemIndex !== undefined && currentItemIndex !== itemIndex) {
      items[currentItemIndex].removeAttribute("open");
      items[currentItemIndex].classList.remove("block_megamenu");
    }

    // Open the current menu
    currentItemIndex = itemIndex;
    item.setAttribute("open", true);
    item.classList.add("block_megamenu");
  });

    item.addEventListener("mouseleave", () => {
        if(!item.classList.contains('megamenu-search-open')){
            let close = true;
            const closeTimeout = setTimeout(() => {
                if (close) {
                    // Hide the search widget
                    document.querySelector('.search-modal__close-button').click();
                    item.removeAttribute("open");
                    item.classList.remove("block_megamenu");
                }
            }, 500);

            content.addEventListener("mouseover", () => {
                close = false;
                clearTimeout(closeTimeout);
            });

            item.addEventListener("mouseover", () => {
                clearTimeout(closeTimeout);
            });

            content.addEventListener("mouseleave", () => {
                const leaveTimeout = setTimeout(() => {
                    // Hide the search widget
                   // document.querySelector('.search-modal__close-button').click();
                   // item.removeAttribute("open");
                   // item.classList.remove("block_megamenu");
                }, 500);
                
                item.addEventListener("mouseover", () => {
                    clearTimeout(leaveTimeout);
                });
            });
        }else{
            
        }

    });  

    let Boostpopupinfo = setInterval(Boostpopup, 5000);

    function Boostpopup() {
      if(!document.querySelector("#boost-sd__search-widget-init-wrapper")){
        setInterval(Boostpopup, 5000);
      }else{
        clearInterval(Boostpopupinfo);
        document.querySelector("#boost-sd__search-widget-init-wrapper").addEventListener("mouseover", () => {
            // Hide the search widget
        });
        document.querySelector("#boost-sd__search-widget-init-wrapper").addEventListener("mouseleave", () => {
            // Hide the search widget
            document.querySelector('.search-modal__close-button').click();
            item.removeAttribute("open");
            item.classList.remove("block_megamenu");
            item.classList.remove('megamenu-search-open');
            document.body.classList.remove('boost-menu-search-opening');
        });
      }
    }
       
    item.querySelector('.search-modal__form input.search__input').addEventListener("focus",(searchtxt)=> {
        item.classList.add('megamenu-search-open');
        document.body.classList.add('boost-menu-search-opening');
        item.setAttribute("open", true);
        item.classList.add("block_megamenu");
    });

    item.querySelector('.search-modal__form input.search__input').addEventListener("keyup",(searchtxt)=> {
        current_item = item;
        if(item.querySelector('.search-modal__form input.search__input').value.length >= 0){
            item.classList.add('megamenu-search-open');
            document.body.classList.add('boost-menu-search-opening');
        }else{
            item.classList.remove('megamenu-search-open');
            document.body.classList.remove('boost-menu-search-opening');
            document.querySelector('.search-modal__close-button').click();
                    //item.removeAttribute("open");
                  // item.classList.remove("block_megamenu");
        }
    });
    
});


$(document).ready(function() {
    var itemsPerPage = 12;
    var $items = $('.block__pressnews--box');
    var totalItems = $items.length;
    var totalPages = Math.ceil(totalItems / itemsPerPage);

    function showPage(page) {
        $items.hide();
        var start = (page - 1) * itemsPerPage;
        var end = start + itemsPerPage;
        $items.slice(start, end).show();
    }

    function createPagination() {
        var $pagination = $('#pagination');
        $pagination.empty();
        
        if (totalPages > 1) {
            $pagination.append('<a href="#" class="prev  disabled"></a>');

            for (var i = 1; i <= totalPages; i++) {
                $pagination.append('<a href="#" class="page-num">' + i + '</a>');
            }

            $pagination.append('<a href="#" class="next"></a>');
        }
        
        $pagination.find('.page-num').first().addClass('active');
    }

    function updatePagination(page) {
        $('#pagination a').removeClass('active');
        $('#pagination a.page-num').eq(page - 1).addClass('active');
        $('#pagination a.prev').toggleClass('disabled', page === 1);
        $('#pagination a.next').toggleClass('disabled', page === totalPages);
    }

    $(document).on('click', '#pagination a.page-num', function(e) {
        e.preventDefault();
        var page = $(this).text();
        showPage(page);
        updatePagination(page);
    });

    $(document).on('click', '#pagination a.prev', function(e) {
        e.preventDefault();
        var currentPage = $('#pagination a.active').text();
        var prevPage = parseInt(currentPage) - 1;
        if (prevPage > 0) {
            showPage(prevPage);
            updatePagination(prevPage);
        }
    });

    $(document).on('click', '#pagination a.next', function(e) {
        e.preventDefault();
        var currentPage = $('#pagination a.active').text();
        var nextPage = parseInt(currentPage) + 1;
        if (nextPage <= totalPages) {
            showPage(nextPage);
            updatePagination(nextPage);
        }
    });

    showPage(1);
    createPagination();
});



// collection filter hide 

let filter = document.querySelector('#main-collection-filters')
let count = 0;
if(filter){
let data_size = filter.getAttribute('data-count')

if (data_size == count) {
    filter.style.display='none'
}
}

// Cart drawer (Smart cart) input change
let cartdrawerinfo = setInterval(CartdrawerRebuy, 8000);

    function CartdrawerRebuy() {
      if(document.querySelectorAll(".rebuy-cart__flyout-item").length == 0){
        setInterval(cartdrawerinfo, 8000);
      }else{
        clearInterval(cartdrawerinfo);
        var cartItem_row =  document.querySelectorAll(".rebuy-cart__flyout-item");
        cartItem_row.forEach((item, itemIndex) => {
        var qtyinput_box = item.querySelector(".rebuy-cart__flyout-item-quantity-widget-label");
        qtyinput_box.addEventListener("change", function (e) {
            setTimeout(function(){
                var Cartitem = window.Rebuy.Cart;
                var cart_total = Cartitem.subtotal();
                var cart_free_total = 150000;
                    if(cart_total > cart_free_total){
                        if(document.querySelector(".rebuy-cart__flyout-subtotal-amount")){
                            document.querySelector(".rebuy-cart__flyout-subtotal-amount").classList.add("freeshipping-enable");
                        }
                    }else{
                        if(document.querySelector(".rebuy-cart__flyout-subtotal-amount")){
                            console.log(document.querySelector(".rebuy-cart__flyout-subtotal-amount"));
                            document.querySelector(".rebuy-cart__flyout-subtotal-amount").classList.remove("freeshipping-enable");
                        }
                    }
            },2200);
            
        });
        });
      }
    }


    // collection tab view all button js 
    
      